import React from 'react';

const NamePositionMarker = ({ image, position, setPosition }) => {
  const handleClick = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setPosition({ x, y });
  };

  return (
    <div className="space-y-4">
      <div className="relative cursor-crosshair" onClick={handleClick}>
        <img 
          src={image} 
          alt="Invitation" 
          className="w-full h-auto max-h-[70vh] object-contain"
        />
        <div
          className="absolute w-4 h-4 bg-red-500 rounded-full border-2 border-white shadow-lg"
          style={{
            left: `${position.x}%`,
            top: `${position.y}%`,
            transform: 'translate(-50%, -50%)'
          }}
        />
      </div>
      <p className="text-sm text-gray-500 text-center">
        Click anywhere on the image to set name position
      </p>
    </div>
  );
};

export default NamePositionMarker;